import { motion } from 'framer-motion';
import CharityStackLogo from '../assets/CharityStack Text.png';

const NotFound = () => (
  <div className="min-h-screen flex flex-col justify-center items-center relative bg-gradient-to-br from-paper-light to-paper-muted overflow-hidden px-4 sm:px-6 lg:px-8">
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="relative z-10 text-center bg-paper-light bg-opacity-80 p-8 sm:p-12 rounded-lg shadow-xl backdrop-filter backdrop-blur-sm max-w-md w-full"
    >
      <motion.img
        src={CharityStackLogo}
        alt="CharityStack Logo"
        className="w-32 h-auto mb-3 sm:w-40 mx-auto" // Added mx-auto here
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
      />
      <motion.h1
        className="text-6xl sm:text-8xl font-black text-ink mb-4 sm:mb-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        404
      </motion.h1>
      <motion.h2
        className="text-xl sm:text-2xl font-semibold text-ink-secondary mb-6 sm:mb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        Page Not Found
      </motion.h2>
      <motion.p
        className="text-sm sm:text-md text-ink-muted mb-8 sm:mb-12 max-w-md mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.6 }}
      >
        We apologize, but the page you&apos;re looking for cannot be found. It may have been moved,
        deleted, or never existed. Let&apos;s get you back on track.
      </motion.p>
      <motion.a
        href={`${window.location.origin}/dashboard`}
        className="inline-block px-6 sm:px-8 py-2 sm:py-3 bg-paper-muted text-ink font-medium rounded-full hover:bg-paper-inset transition duration-300"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Return to Dashboard
      </motion.a>
    </motion.div>
  </div>
);

export default NotFound;
